import { render, staticRenderFns } from "./XcqBigAndMiddleImg.vue?vue&type=template&id=7d15734d&scoped=true"
import script from "./XcqBigAndMiddleImg.vue?vue&type=script&lang=ts"
export * from "./XcqBigAndMiddleImg.vue?vue&type=script&lang=ts"
import style0 from "./XcqBigAndMiddleImg.vue?vue&type=style&index=0&id=7d15734d&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d15734d",
  null
  
)

export default component.exports